import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useSelector } from 'react-redux'

interface Props {
  children: React.ReactNode
}

const GoogleReCaptchaWrapper = (props: Props) => {
  const { children = null } = props

  const { recaptchaRequired } = useSelector((state: any) => state?.pagina)

  return (
    <GoogleReCaptchaProvider
      useEnterprise
      reCaptchaKey={recaptchaRequired ? process.env.RECAPTCHA_SITE_KEY : undefined}
      {...(recaptchaRequired
        ? {
            container: {
              element: 'ca_recaptcha_badge',
              parameters: {
                badge: 'bottomright',
                theme: 'light',
              },
            },
          }
        : {})}
    >
      {children}
      <div id="ca_recaptcha_badge" />
    </GoogleReCaptchaProvider>
  )
}

export default GoogleReCaptchaWrapper
